import Vue from "vue";
import moment from "moment";

import { unitTypes } from "@/settings/unitTypes";

Vue.filter("formatWithIntl", date => {
  if (!date) {
    return "Invalid Date";
  }
  return new Intl.DateTimeFormat("es-VE").format(new Date(date));
});
Vue.filter("formatNumber", num => {
  if (!num) {
    return 0;
  }
  let val = (num / 1).toFixed(2).replace(",", ".");
  return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});
Vue.filter("formatMiles", num => {
  if (!num) {
    return 0;
  }
  let val = num / 1000;
  return val;
});
Vue.filter("formatDate", (date, locale = "en") => {
  moment.locale(locale);
  let val = moment(new Date(date.seconds * 1000)).format(
    "MMMM D YYYY, h:mm:ss a"
  );
  return val;
});
Vue.filter("planAPI", val => {
  return val ? "Active" : "Disabled";
});
Vue.filter("dateUntil", date => {
  var now = moment();

  let val = moment(date.toDate()).endOf("hour");

  return now.to(val);
});
Vue.filter("capitalize", str => {
  if (str.length > 0) {
    const wordsArray = str.split(/(?=[A-Z])/);
    const capitalizedWords = wordsArray.map(word => {
      const capitalizedWord = `${word[0].toUpperCase()}${word.slice(1)}`;
      return capitalizedWord;
    });
    return capitalizedWords.join(" ");
  } else {
    return "";
  }
});

Vue.filter("fiveCyphers", (val, type) => {
  if (type === unitTypes.percentage) return Number.parseFloat(val).toFixed(2);
  return Number.parseFloat(val).toPrecision(4);
});
Vue.filter("ifExponential", (val, type) => {
  if (type === unitTypes.percentage) return val;
  if ((val < 0.1 && val > -0.1) || (val > 10000 && val < -100000))
    return Number.parseFloat(val).toExponential(3);
  return val;
});
